import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_down",
  "use": "icon-arrow_down-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol viewBox=\"0 0 19 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_down\"><g id=\"icon-arrow_down_ç®­å¤´ä¸\"><path id=\"icon-arrow_down_Line Copy 15\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.5 6.80844L13.7208 6L9.5 10.379L5.27922 6L4.5 6.80844L9.5 12L14.5 6.80844Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol